export interface Behavior {
    behavior: string;
    content: string;
    behaviorPresent: 0 | 1;
    behaviorLine: string[];
}
